import { render, staticRenderFns } from "./AccountsTab.vue?vue&type=template&id=a0cc640c&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./AccountsTab.vue?vue&type=script&lang=js&"
export * from "./AccountsTab.vue?vue&type=script&lang=js&"
import style0 from "./AccountsTab.vue?vue&type=style&index=0&id=a0cc640c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0cc640c",
  null
  
)

export default component.exports